module.exports = __webpack_public_path__ + "static/media/customize-icon.7c1a6f97.svg";